import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RegistrationBenefits = () => {
  const benefits = [
    {
      icon: 'Search',
      title: 'Vergelijk Providers',
      description: 'Vind en vergelijk gecertificeerde duurzaamheidsproviders in uw regio'
    },
    {
      icon: 'FileText',
      title: 'Ontvang Offertes',
      description: 'Vraag eenvoudig meerdere offertes aan en vergelijk prijzen en services'
    },
    {
      icon: 'Shield',
      title: 'Kwaliteitsgarantie',
      description: 'Alle providers zijn geverifieerd en hebben beoordelingen van echte klanten'
    },
    {
      icon: 'Headphones',
      title: 'Persoonlijke Ondersteuning',
      description: 'Krijg hulp van onze experts bij het kiezen van de juiste oplossing'
    },
    {
      icon: 'TrendingUp',
      title: 'Bespaar op Energiekosten',
      description: 'Ontdek hoeveel u kunt besparen met duurzame home improvements'
    },
    {
      icon: 'Award',
      title: 'Subsidie Informatie',
      description: 'Krijg actuele informatie over beschikbare subsidies en financiering'
    }
  ];

  const testimonials = [
    {
      name: 'Maria van der Berg',
      location: 'Amsterdam',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=64&h=64&fit=crop&crop=face',
      text: 'Dankzij Verduurzaamwijzer heb ik de perfecte zonnepanelen installateur gevonden. Zeer tevreden!'
    },
    {
      name: 'Jan Hendriks',
      location: 'Utrecht',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=64&h=64&fit=crop&crop=face',
      text: 'Snelle service en betrouwbare providers. Mijn warmtepomp is perfect geïnstalleerd.'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Main Benefits */}
      <div>
        <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
          Waarom kiezen voor Verduurzaamwijzer?
        </h3>
        
        <div className="grid grid-cols-1 gap-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <h4 className="font-heading font-medium text-foreground mb-1">
                  {benefit?.title}
                </h4>
                <p className="text-sm font-body text-muted-foreground">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Customer Testimonials */}
      <div>
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          Wat onze klanten zeggen
        </h3>
        
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="bg-muted/30 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <Image
                  src={testimonial?.avatar}
                  alt={`${testimonial?.name} avatar`}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="flex-1">
                  <p className="text-sm font-body text-foreground mb-2">
                    "{testimonial?.text}"
                  </p>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-caption font-medium text-foreground">
                      {testimonial?.name}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      • {testimonial?.location}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Trust Indicators */}
      <div className="bg-success/5 border border-success/20 rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Shield" size={18} color="var(--color-success)" />
          <span className="font-heading font-medium text-success">
            100% Veilig & Betrouwbaar
          </span>
        </div>
        
        <div className="grid grid-cols-2 gap-3 text-xs font-body text-success">
          <div className="flex items-center space-x-1">
            <Icon name="Check" size={12} />
            <span>GDPR Compliant</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Check" size={12} />
            <span>SSL Beveiligd</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Check" size={12} />
            <span>KvK Geregistreerd</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Check" size={12} />
            <span>Geverifieerde Providers</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationBenefits;